import { faBookmark, faComment } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import { faFacebook, faTwitter, faWhatsapp, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { Helmet } from 'react-helmet-async';

const GroupTravel = () => {
  return (
    <>
      <Helmet>
        <title>Making Group Travel Easier for Weddings & Family Functions</title>
        <meta
          name="description"
          content="Learn how to simplify group travel for weddings and family functions using rental vans. Comfortable, reliable, and stress-free transportation tips."
        />
      </Helmet>
      <div className="bg-[#fff] w-full flex flex-col">
        <section
          className="hero--container relative flex flex-col justify-center w-full bg-no-repeat bg-cover bg-center pt-[65px] mt-[140px] md:h-[60vh]"
          style={{ backgroundImage: `url('../images/group-travel.jpg')` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>
          <div className="relative z-10">
            <h1 className="text-center text-white text-2xl md:text-5xl font-bold uppercase leading-9">
              Making Group Travel Easier for Weddings and Family Functions
            </h1>

            <div className="flex justify-center items-center gap-4 mt-10 md:text-sm text-xs mb-2">
              <div className="flex items-center gap-2 text-white">
                <FontAwesomeIcon icon={faClock} className="w-4" />
                <p className="blog-publish-date">01/02/2026</p>
              </div>

              <div className="flex items-center gap-2 text-white">
                <FontAwesomeIcon icon={faComment} className="w-4" />
                <p className="blog-publish-date">9 Comments</p>
              </div>

              <div className="flex items-center gap-2 text-white">
                <FontAwesomeIcon icon={faBookmark} />
                <p className="blog-publish-date">2740 Views</p>
              </div>
            </div>
          </div>
        </section>

        <section className="body--container w-full px-4 py-8 md:py-10 md:px-12 lg:px-16 xl:px-20 2xl:px-24">
          <div className="mx-auto max-w-screen-md">
            <p className="pb-4 text-justify leading-7">
              Weddings and family functions are joyful celebrations—but coordinating travel for a large group can be overwhelming. From getting everyone to the venue on time to ensuring they travel comfortably, transportation plays a crucial role in making your special event run smoothly.
            </p>

            <p className="pb-4 text-justify leading-7">
              Renting a van is one of the most practical and convenient solutions for group travel during weddings and family events. Whether it's transporting the bridal party, elderly guests, or out-of-town relatives, a spacious van ensures everyone stays together and arrives stress-free.
            </p>

            <p className="pb-4 text-justify leading-7">
              JJ Van Rental offers a range of passenger vans that cater to different group sizes. Our clean, well-maintained vehicles are ideal for both short and long-distance travel. We even offer delivery to your home, office, or airport for added convenience, so your group doesn’t have to worry about pick-up logistics.
            </p>

            <p className="pb-4 text-justify leading-7">
              Coordinating transportation for special occasions also saves time and minimizes the chances of delays. You can plan ahead, stick to a schedule, and provide your guests with a reliable and enjoyable experience. No need to juggle rideshares or multiple cars—just one vehicle, one plan, and total peace of mind.
            </p>

            <p className="pb-4 text-justify leading-7">
              At JJ Van Rental, we understand the importance of smooth travel for meaningful events. Whether it's a small family function or a grand wedding celebration, we make sure your group transportation is easy, affordable, and comfortable.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <div className="max-w-screen-md mx-auto px-4 py-3 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            {/* Tags Section */}
            <div className="flex flex-wrap gap-2">
              <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Group Travel</p>
              <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Weddings</p>
              <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Family Functions</p>
            </div>

            {/* Social Buttons Section */}
            <div className="flex flex-wrap items-center gap-3">
              <div className="flex items-center bg-[#42599E] px-3 py-2 rounded-lg text-white text-sm">
                <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1">
                  <FontAwesomeIcon icon={faFacebook} /> Share
                </a>
              </div>
              <div className="flex items-center bg-[#55ACEE] px-3 py-2 rounded-lg text-white text-sm">
                <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1">
                  <FontAwesomeIcon icon={faTwitter} /> Tweet
                </a>
              </div>
              <div className="flex items-center bg-[#34AF23] px-3 py-2 rounded-lg text-white text-sm">
                <a href="https://www.whatsapp.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1">
                  <FontAwesomeIcon icon={faWhatsapp} /> WhatsApp
                </a>
              </div>
              <div className="flex items-center bg-[#0798CF] px-3 py-2 rounded-lg text-white text-sm">
                <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1">
                  <FontAwesomeIcon icon={faLinkedin} /> LinkedIn
                </a>
              </div>
            </div>
          </div>

        </section>
      </div>
    </>

  );
};

export default GroupTravel;